'use strict';

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _get = require('just-safe-get');

var debug = require('debug');

var errCode = require('err-code');

var migrator = require('ipfs-repo-migrations');

var bytes = require('bytes');

var merge = require('merge-options');

var constants = require('./constants.js');

var version = require('./version.js');

var config = require('./config.js');

var spec = require('./spec.js');

var apiAddr = require('./api-addr.js');

var idstore = require('./idstore.js');

var defaultOptions = require('./default-options.js');

var defaultDatastore = require('./default-datastore.js');

var errors = require('./errors.js');

var pinManager = require('./pin-manager.js');

var pinnedBlockstore = require('./pinned-blockstore.js');

var mortice = require('mortice');

var gc = require('./gc.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var migrator__namespace = /*#__PURE__*/_interopNamespace(migrator);

var bytes__default = /*#__PURE__*/_interopDefaultLegacy(bytes);

var merge__default = /*#__PURE__*/_interopDefaultLegacy(merge);

var mortice__default = /*#__PURE__*/_interopDefaultLegacy(mortice);

var log = debug__default["default"]('ipfs:repo');
var noLimit = Number.MAX_SAFE_INTEGER;
var AUTO_MIGRATE_CONFIG_KEY = 'repoAutoMigrate';

var Repo = /*#__PURE__*/function () {
  function Repo(path, loadCodec, backends, options) {
    _classCallCheck(this, Repo);

    if (typeof path !== 'string') {
      throw new Error('missing repo path');
    }

    if (typeof loadCodec !== 'function') {
      throw new Error('missing codec loader');
    }

    this.options = merge__default["default"](defaultOptions, options);
    this.closed = true;
    this.path = path;
    this.root = backends.root;
    this.datastore = backends.datastore;
    this.keys = backends.keys;
    var blockstore = backends.blocks;
    var pinstore = backends.pins;
    this.pins = new pinManager.PinManager({
      pinstore: pinstore,
      blockstore: blockstore,
      loadCodec: loadCodec
    });
    var pinnedBlockstore$1 = pinnedBlockstore.createPinnedBlockstore(this.pins, blockstore);
    this.blocks = idstore.createIdStore(pinnedBlockstore$1);
    this.version = version.version(this.root);
    this.config = config.config(this.root);
    this.spec = spec.spec(this.root);
    this.apiAddr = apiAddr.apiAddr(this.root);
    this.gcLock = mortice__default["default"](path, {
      singleProcess: this.options.repoOwner !== false
    });
    this.gc = gc.gc({
      gcLock: this.gcLock,
      pins: this.pins,
      blockstore: this.blocks,
      root: this.root,
      loadCodec: loadCodec
    });
  }

  _createClass(Repo, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                log('initializing at: %s', this.path);
                _context.next = 3;
                return this._openRoot();

              case 3:
                _context.next = 5;
                return this.config.replace(buildConfig(config));

              case 5:
                _context.next = 7;
                return this.spec.set(buildDatastoreSpec(config));

              case 7:
                _context.next = 9;
                return this.version.set(constants.repoVersion);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init(_x) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "isInitialized",
    value: function () {
      var _isInitialized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.closed) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", true);

              case 2:
                _context2.prev = 2;
                _context2.next = 5;
                return this._openRoot();

              case 5:
                _context2.next = 7;
                return this._checkInitialized();

              case 7:
                _context2.next = 9;
                return this.root.close();

              case 9:
                return _context2.abrupt("return", true);

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](2);
                return _context2.abrupt("return", false);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 12]]);
      }));

      function isInitialized() {
        return _isInitialized.apply(this, arguments);
      }

      return isInitialized;
    }()
  }, {
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var isCompatible;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.closed) {
                  _context3.next = 2;
                  break;
                }

                throw errCode__default["default"](new Error('repo is already open'), errors.ERR_REPO_ALREADY_OPEN);

              case 2:
                log('opening at: %s', this.path);
                _context3.prev = 3;
                _context3.next = 6;
                return this._openRoot();

              case 6:
                _context3.next = 8;
                return this._checkInitialized();

              case 8:
                _context3.next = 10;
                return this._openLock();

              case 10:
                this._lockfile = _context3.sent;
                log('acquired repo.lock');
                _context3.next = 14;
                return this.version.check(constants.repoVersion);

              case 14:
                isCompatible = _context3.sent;

                if (isCompatible) {
                  _context3.next = 24;
                  break;
                }

                _context3.next = 18;
                return this._isAutoMigrationEnabled();

              case 18:
                if (!_context3.sent) {
                  _context3.next = 23;
                  break;
                }

                _context3.next = 21;
                return this._migrate(constants.repoVersion, {
                  root: this.root,
                  datastore: this.datastore,
                  pins: this.pins.pinstore,
                  blocks: this.pins.blockstore,
                  keys: this.keys
                });

              case 21:
                _context3.next = 24;
                break;

              case 23:
                throw new errors.InvalidRepoVersionError('Incompatible repo versions. Automatic migrations disabled. Please migrate the repo manually.');

              case 24:
                log('creating datastore');
                _context3.next = 27;
                return this.datastore.open();

              case 27:
                log('creating blocks');
                this.blocks.open();
                log('creating keystore');
                _context3.next = 32;
                return this.keys.open();

              case 32:
                log('creating pins');
                _context3.next = 35;
                return this.pins.pinstore.open();

              case 35:
                this.closed = false;
                log('all opened');
                _context3.next = 52;
                break;

              case 39:
                _context3.prev = 39;
                _context3.t0 = _context3["catch"](3);

                if (!this._lockfile) {
                  _context3.next = 51;
                  break;
                }

                _context3.prev = 42;
                _context3.next = 45;
                return this._closeLock();

              case 45:
                this._lockfile = null;
                _context3.next = 51;
                break;

              case 48:
                _context3.prev = 48;
                _context3.t1 = _context3["catch"](42);
                log('error removing lock', _context3.t1);

              case 51:
                throw _context3.t0;

              case 52:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 39], [42, 48]]);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "_openRoot",
    value: function () {
      var _openRoot2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.root.open();

              case 3:
                _context4.next = 9;
                break;

              case 5:
                _context4.prev = 5;
                _context4.t0 = _context4["catch"](0);

                if (!(_context4.t0.message !== 'Already open')) {
                  _context4.next = 9;
                  break;
                }

                throw _context4.t0;

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 5]]);
      }));

      function _openRoot() {
        return _openRoot2.apply(this, arguments);
      }

      return _openRoot;
    }()
  }, {
    key: "_openLock",
    value: function () {
      var _openLock2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var lockfile;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.options.repoLock.lock(this.path);

              case 2:
                lockfile = _context5.sent;

                if (!(typeof lockfile.close !== 'function')) {
                  _context5.next = 5;
                  break;
                }

                throw errCode__default["default"](new Error('Locks must have a close method'), 'ERR_NO_CLOSE_FUNCTION');

              case 5:
                return _context5.abrupt("return", lockfile);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _openLock() {
        return _openLock2.apply(this, arguments);
      }

      return _openLock;
    }()
  }, {
    key: "_closeLock",
    value: function _closeLock() {
      return this._lockfile && this._lockfile.close();
    }
  }, {
    key: "_checkInitialized",
    value: function () {
      var _checkInitialized2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var config, _yield$Promise$all, _yield$Promise$all2;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                log('init check');
                _context6.prev = 1;
                _context6.next = 4;
                return Promise.all([this.config.exists(), this.spec.exists(), this.version.exists()]);

              case 4:
                _yield$Promise$all = _context6.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
                config = _yield$Promise$all2[0];
                _context6.next = 14;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6["catch"](1);

                if (!(_context6.t0.code === 'ERR_NOT_FOUND')) {
                  _context6.next = 13;
                  break;
                }

                throw errCode__default["default"](new Error('repo is not initialized yet'), errors.ERR_REPO_NOT_INITIALIZED, {
                  path: this.path
                });

              case 13:
                throw _context6.t0;

              case 14:
                if (config) {
                  _context6.next = 16;
                  break;
                }

                throw errCode__default["default"](new Error('repo is not initialized yet'), errors.ERR_REPO_NOT_INITIALIZED, {
                  path: this.path
                });

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[1, 9]]);
      }));

      function _checkInitialized() {
        return _checkInitialized2.apply(this, arguments);
      }

      return _checkInitialized;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!this.closed) {
                  _context7.next = 2;
                  break;
                }

                throw errCode__default["default"](new Error('repo is already closed'), errors.ERR_REPO_ALREADY_CLOSED);

              case 2:
                log('closing at: %s', this.path);
                _context7.prev = 3;
                _context7.next = 6;
                return this.apiAddr.delete();

              case 6:
                _context7.next = 12;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7["catch"](3);

                if (!(_context7.t0.code !== errors.ERR_REPO_NOT_INITIALIZED && !_context7.t0.message.startsWith('ENOENT'))) {
                  _context7.next = 12;
                  break;
                }

                throw _context7.t0;

              case 12:
                _context7.next = 14;
                return Promise.all([this.root, this.blocks, this.keys, this.datastore, this.pins.pinstore].map(function (store) {
                  return store && store.close();
                }));

              case 14:
                log('unlocking');
                this.closed = true;
                _context7.next = 18;
                return this._closeLock();

              case 18:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[3, 8]]);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "exists",
    value: function exists() {
      return this.version.exists();
    }
  }, {
    key: "stat",
    value: function () {
      var _stat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _yield$Promise$all3, _yield$Promise$all4, storageMax, blocks, _version, datastore, keys, size;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(this.datastore && this.keys)) {
                  _context8.next = 12;
                  break;
                }

                _context8.next = 3;
                return Promise.all([this._storageMaxStat(), this._blockStat(), this.version.get(), getSize(this.datastore), getSize(this.keys)]);

              case 3:
                _yield$Promise$all3 = _context8.sent;
                _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 5);
                storageMax = _yield$Promise$all4[0];
                blocks = _yield$Promise$all4[1];
                _version = _yield$Promise$all4[2];
                datastore = _yield$Promise$all4[3];
                keys = _yield$Promise$all4[4];
                size = blocks.size + datastore + keys;
                return _context8.abrupt("return", {
                  repoPath: this.path,
                  storageMax: storageMax,
                  version: _version,
                  numObjects: blocks.count,
                  repoSize: size
                });

              case 12:
                throw errCode__default["default"](new Error('repo is not initialized yet'), errors.ERR_REPO_NOT_INITIALIZED, {
                  path: this.path
                });

              case 13:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function stat() {
        return _stat.apply(this, arguments);
      }

      return stat;
    }()
  }, {
    key: "_isAutoMigrationEnabled",
    value: function () {
      var _isAutoMigrationEnabled2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var autoMigrateConfig;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(this.options.autoMigrate !== undefined)) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt("return", this.options.autoMigrate);

              case 2:
                _context9.prev = 2;
                _context9.next = 5;
                return this.config.get(AUTO_MIGRATE_CONFIG_KEY);

              case 5:
                autoMigrateConfig = _context9.sent;
                _context9.next = 15;
                break;

              case 8:
                _context9.prev = 8;
                _context9.t0 = _context9["catch"](2);

                if (!(_context9.t0.code === errors.NotFoundError.code)) {
                  _context9.next = 14;
                  break;
                }

                autoMigrateConfig = true;
                _context9.next = 15;
                break;

              case 14:
                throw _context9.t0;

              case 15:
                return _context9.abrupt("return", autoMigrateConfig);

              case 16:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[2, 8]]);
      }));

      function _isAutoMigrationEnabled() {
        return _isAutoMigrationEnabled2.apply(this, arguments);
      }

      return _isAutoMigrationEnabled;
    }()
  }, {
    key: "_migrate",
    value: function () {
      var _migrate2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(toVersion, backends) {
        var currentRepoVersion;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.version.get();

              case 2:
                currentRepoVersion = _context10.sent;

                if (!(currentRepoVersion > toVersion)) {
                  _context10.next = 8;
                  break;
                }

                log("reverting to version ".concat(toVersion));
                return _context10.abrupt("return", migrator__namespace.revert(this.path, backends, this.options, toVersion, {
                  ignoreLock: true,
                  onProgress: this.options.onMigrationProgress
                }));

              case 8:
                log("migrating to version ".concat(toVersion));
                return _context10.abrupt("return", migrator__namespace.migrate(this.path, backends, this.options, toVersion, {
                  ignoreLock: true,
                  onProgress: this.options.onMigrationProgress
                }));

              case 10:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function _migrate(_x2, _x3) {
        return _migrate2.apply(this, arguments);
      }

      return _migrate;
    }()
  }, {
    key: "_storageMaxStat",
    value: function () {
      var _storageMaxStat2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var max;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return this.config.get('Datastore.StorageMax');

              case 3:
                max = _context11.sent;
                return _context11.abrupt("return", BigInt(bytes__default["default"](max)));

              case 7:
                _context11.prev = 7;
                _context11.t0 = _context11["catch"](0);
                return _context11.abrupt("return", BigInt(noLimit));

              case 10:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 7]]);
      }));

      function _storageMaxStat() {
        return _storageMaxStat2.apply(this, arguments);
      }

      return _storageMaxStat;
    }()
  }, {
    key: "_blockStat",
    value: function () {
      var _blockStat2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var count, size, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step$value, key, value;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                count = BigInt(0);
                size = BigInt(0);

                if (!this.blocks) {
                  _context12.next = 33;
                  break;
                }

                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context12.prev = 5;
                _iterator = _asyncIterator(this.blocks.query({}));

              case 7:
                _context12.next = 9;
                return _iterator.next();

              case 9:
                if (!(_iteratorAbruptCompletion = !(_step = _context12.sent).done)) {
                  _context12.next = 17;
                  break;
                }

                _step$value = _step.value, key = _step$value.key, value = _step$value.value;
                count += BigInt(1);
                size += BigInt(value.byteLength);
                size += BigInt(key.bytes.byteLength);

              case 14:
                _iteratorAbruptCompletion = false;
                _context12.next = 7;
                break;

              case 17:
                _context12.next = 23;
                break;

              case 19:
                _context12.prev = 19;
                _context12.t0 = _context12["catch"](5);
                _didIteratorError = true;
                _iteratorError = _context12.t0;

              case 23:
                _context12.prev = 23;
                _context12.prev = 24;

                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context12.next = 28;
                  break;
                }

                _context12.next = 28;
                return _iterator.return();

              case 28:
                _context12.prev = 28;

                if (!_didIteratorError) {
                  _context12.next = 31;
                  break;
                }

                throw _iteratorError;

              case 31:
                return _context12.finish(28);

              case 32:
                return _context12.finish(23);

              case 33:
                return _context12.abrupt("return", {
                  count: count,
                  size: size
                });

              case 34:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[5, 19, 23, 33], [24,, 28, 32]]);
      }));

      function _blockStat() {
        return _blockStat2.apply(this, arguments);
      }

      return _blockStat;
    }()
  }]);

  return Repo;
}();

function getSize(_x4) {
  return _getSize.apply(this, arguments);
}

function _getSize() {
  _getSize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(datastore) {
    var sum, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, block;

    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            sum = BigInt(0);
            _iteratorAbruptCompletion2 = false;
            _didIteratorError2 = false;
            _context13.prev = 3;
            _iterator2 = _asyncIterator(datastore.query({}));

          case 5:
            _context13.next = 7;
            return _iterator2.next();

          case 7:
            if (!(_iteratorAbruptCompletion2 = !(_step2 = _context13.sent).done)) {
              _context13.next = 14;
              break;
            }

            block = _step2.value;
            sum += BigInt(block.value.byteLength);
            sum += BigInt(block.key.uint8Array().byteLength);

          case 11:
            _iteratorAbruptCompletion2 = false;
            _context13.next = 5;
            break;

          case 14:
            _context13.next = 20;
            break;

          case 16:
            _context13.prev = 16;
            _context13.t0 = _context13["catch"](3);
            _didIteratorError2 = true;
            _iteratorError2 = _context13.t0;

          case 20:
            _context13.prev = 20;
            _context13.prev = 21;

            if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
              _context13.next = 25;
              break;
            }

            _context13.next = 25;
            return _iterator2.return();

          case 25:
            _context13.prev = 25;

            if (!_didIteratorError2) {
              _context13.next = 28;
              break;
            }

            throw _iteratorError2;

          case 28:
            return _context13.finish(25);

          case 29:
            return _context13.finish(20);

          case 30:
            return _context13.abrupt("return", sum);

          case 31:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[3, 16, 20, 30], [21,, 25, 29]]);
  }));
  return _getSize.apply(this, arguments);
}

function createRepo(path, loadCodec, backends, options) {
  return new Repo(path, loadCodec, backends, options);
}

function buildConfig(_config) {
  _config.Datastore = Object.assign({}, defaultDatastore, _get__default["default"](_config, 'datastore'));
  return _config;
}

function buildDatastoreSpec(_config) {
  var spec = _objectSpread(_objectSpread({}, defaultDatastore.Spec), _get__default["default"](_config, 'Datastore.Spec'));

  return {
    type: spec.type,
    mounts: spec.mounts.map(function (mounting) {
      return {
        mountpoint: mounting.mountpoint,
        type: mounting.child.type,
        path: mounting.child.path,
        shardFunc: mounting.child.shardFunc
      };
    })
  };
}

exports.createRepo = createRepo;